import { normalizarTalla, compararTallas } from './tallas';

// Agrupamiento genérico de productos por una "dimensión": talla o marca.
// Cada valor distinto es su propia tarjeta (34B, 34C, Leonisa, Victoria's...).

export const DIMENSIONES = {
  subtipo: { etiqueta: 'Tipo', prefijoTarjeta: '', icono: '🧷', sinLabel: 'Sin tipo' },
  talla: { etiqueta: 'Talla', prefijoTarjeta: 'Talla ', icono: '📏', sinLabel: 'Sin talla' },
  marca: { etiqueta: 'Marca', prefijoTarjeta: '', icono: '🏷️', sinLabel: 'Sin marca' },
};

// Dimensiones que agrupan sin distinguir mayúsculas (texto libre).
const DIM_TEXTO = new Set(['marca', 'subtipo']);

// Valor "crudo" del producto en una dimensión (talla en mayúsculas, texto sin espacios).
const valorCrudo = (producto, dimension) => {
  if (dimension === 'talla') return normalizarTalla(producto.talla);
  if (dimension === 'subtipo') return (producto.subtipo || '').trim();
  return (producto.marca || '').trim();
};

// ¿La categoría usa esta dimensión? (al menos un producto con valor)
export const categoriaUsa = (productos, categoria, dimension) =>
  productos.some((p) => p.categoria === categoria && valorCrudo(p, dimension));

// Dimensiones disponibles de una categoría, en orden [talla, marca].
export function dimensionesDeCategoria(productos, categoria) {
  const dims = [];
  if (categoriaUsa(productos, categoria, 'subtipo')) dims.push('subtipo');
  if (categoriaUsa(productos, categoria, 'talla')) dims.push('talla');
  if (categoriaUsa(productos, categoria, 'marca')) dims.push('marca');
  return dims;
}

// Valores distintos (ordenados) de una dimensión + si hay productos sin valor.
// La marca agrupa sin distinguir mayúsculas ('Árabe' y 'árabe' se unen).
export function valoresDeDimension(productos, dimension) {
  const mapa = new Map(); // clave normalizada -> texto a mostrar
  let haySin = false;
  productos.forEach((p) => {
    const v = valorCrudo(p, dimension);
    if (!v) { haySin = true; return; }
    const clave = DIM_TEXTO.has(dimension) ? v.toLowerCase() : v;
    if (!mapa.has(clave)) mapa.set(clave, v);
  });
  const valores = [...mapa.values()];
  if (dimension === 'talla') valores.sort(compararTallas);
  else valores.sort((a, b) => a.localeCompare(b, 'es'));
  return { valores, haySin };
}

// ¿El producto coincide con un valor de la dimensión? ('__sin__' = sin valor)
export function coincideDimension(producto, dimension, valor) {
  if (!valor) return true;
  if (valor === '__sin__') return !valorCrudo(producto, dimension);
  const v = valorCrudo(producto, dimension);
  if (DIM_TEXTO.has(dimension)) return v.toLowerCase() === String(valor).toLowerCase();
  return v === normalizarTalla(valor);
}
